import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ApiService } from '../../../../shared/services/api.service';
import { Conversation } from '../../../../shared/models/conversation.model';
import { DisplayChatComponent } from '../display-chat/display-chat.component';

@Component({
  selector: 'app-image-attach-interactions',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
  ],
  templateUrl: './image-attach-interactions.component.html',
  styleUrls: ['./image-attach-interactions.component.scss'],
})
export class ImageInteractionsConversations implements OnInit {
  private apiService = inject(ApiService);
  private dialogRef = inject(MatDialogRef<ImageInteractionsConversations>);
  private bottomSheet = inject(MatBottomSheet);
  private dialogData: {
    startDate?: string;
    endDate?: string;
    period?: string;
    isPlanNumberRevealed: boolean;
  } = inject(MAT_DIALOG_DATA);
  private cdr = inject(ChangeDetectorRef);

  conversations = new MatTableDataSource<Conversation>([]);
  displayedColumns: string[] = [
    'planNumber',
    'productType',
    'sessionId',
    'messageHistory',
  ];

  isLoading = false;
  resultsLength = 0;
  lastEvaluatedKey: string | null = null;
  showPlanNumber: boolean = false;

  ngOnInit(): void {
    this.fetchImageConversations();
  }

  fetchImageConversations(event?: PageEvent): void {
    const pageSize = event?.pageSize || 10;
    this.isLoading = true;
    this.showPlanNumber = this.dialogData.isPlanNumberRevealed;

    let url = `admin/get-bedrock-conversations-with-images?limit=${pageSize}`;
    if (this.dialogData?.startDate) {
      url += `&startDate=${encodeURIComponent(this.dialogData.startDate)}`;
    }
    if (this.dialogData?.endDate) {
      url += `&endDate=${encodeURIComponent(this.dialogData.endDate)}`;
    }
    if (this.lastEvaluatedKey) {
      url += `&lastEvaluatedKey=${this.lastEvaluatedKey}`;
    }

    this.apiService.get<any>(url).subscribe({
      next: (response) => {
        const period = this.dialogData?.period || 'lastDay';
        let data: Conversation[] = [];
        let totalCount = 0;

        const periodData = response?.[period] || response?.['custom'];
        if (periodData?.data) {
          data = periodData.data;
          totalCount = periodData.totalCount || 0;
        } else if (response?.data) {
          data = response.data;
          totalCount = response.totalCount || 0;
        }

        this.conversations.data = data;
        this.isLoading = false;
        this.resultsLength = totalCount;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  viewConversation(conversation: Conversation): void {
    this.bottomSheet.open(DisplayChatComponent, {
      data: {
        messageHistory: conversation.messageHistory,
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
